import { EComissionType } from 'v2/interfaces/product';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  value: Yup.number()
    .when('type', {
      is: EComissionType.VALUE,
      then: (schema) => schema.positive().required().min(1, 'Valor minímo de R$ 1,00'),
    })
    .when('type', {
      is: EComissionType.PERCENTAGE,
      then: (schema) => schema.positive().required().min(1, 'Valor minímo de 1%').max(99, 'Valor máximo de 99%'),
    }),
});

export default validationSchema;
